/**
 * API 配置
 */

// API 基础 URL
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:44182/api/v1';

// API 端点
export const API_ENDPOINTS = {
  // 系统管理模块（对应后端 system_app）
  system_app: {
    // 登录相关
    sendCode: '/system_app/send_code',
    login: '/system_app/login',
    loginByPassword: '/system_app/login_by_password',
    currentUser: '/system_app/current_user',
    // 管理员用户管理
    users: '/system_app/users',
    userDetail: (id: number) => `/system_app/users/${id}`,
    // 角色管理
    roles: '/system_app/roles',
    roleDetail: (id: number) => `/system_app/roles/${id}`,
    // 权限管理
    permissions: '/system_app/permissions',
    // 初始化
    init: '/system_app/init',
  },
  
  // AI管理模块
  ai_management: {
    config: '/ai_management/config',
    test: '/ai_management/test',
    testImage: '/ai_management/test-image',
    testTts: '/ai_management/test-tts',
  },

  // AI费用监控模块
  ai_history: {
    list: '/ai_history',
    stats: '/ai_history/stats',
  },

  // 云存储配置
  storage: {
    providers: '/storage_app/providers',
    providerDetail: (id: number) => `/storage_app/providers/${id}`,
    setDefault: (id: number) => `/storage_app/providers/${id}/default`,
    test: (id: number) => `/storage_app/providers/${id}/test`,
    resources: '/storage_app/resources',
    backgroundMusic: '/storage_app/background-music',
    backgroundMusicUpload: '/storage_app/background-music/upload',
    backgroundMusicBatchDelete: '/storage_app/background-music/batch-delete',
    backgroundMusicDetail: (id: number) => `/storage_app/background-music/${id}`,
    sleepVideos: '/storage_app/sleep-videos',
    sleepVideoDetail: (id: number) => `/storage_app/sleep-videos/${id}`,
    sleepVideoRefreshMedia: (id: number) => `/storage_app/sleep-videos/${id}/refresh-media`,
    dataPullSleepMusic: '/storage_app/data-pull/sleep-music',
    dataPullSleepVideos: '/storage_app/data-pull/sleep-videos',
    dataPullTaskLatest: (resourceType: string) => `/storage_app/data-pull/tasks/latest?resource_type=${resourceType}`,
    dataPullTask: (taskId: string) => `/storage_app/data-pull/tasks/${taskId}`,
    dataPullTaskCancel: (taskId: string) => `/storage_app/data-pull/tasks/${taskId}/cancel`,
    userVoices: '/storage_app/user-voices',
    userVoiceDetail: (id: string) => `/storage_app/user-voices/${id}`,
  },

  // 数据看板
  dashboard: {
    overview: '/dashboard/overview',
  },

  analytics: {
    overview: '/analytics/overview',
    funnel: '/analytics/funnel',
    retention: '/analytics/retention',
    events: '/analytics/events',
  },

  // 产品发布管理
  download: {
    releases: '/download_app/releases',
    releaseUpload: '/download_app/releases/upload',
    releaseDetail: (id: number) => `/download_app/releases/${id}`,
    releaseActive: (id: number) => `/download_app/releases/${id}/active`,
  },

  // 登录配置
  login_config: {
    config: '/login_config/config',
  },

  // 生成管理
  generation_config: {
    config: '/generation_config/config',
  },

  // 北极星运营数据上报
  polaris_app: {
    config: '/polaris/config',
    logs: '/polaris/logs',
    stats: '/polaris/stats',
    connectivityTest: '/polaris/connectivity-test',
  },

  // 广告配置
  ad_config_app: {
    config: '/ad_config_app/config',
    polarisTest: '/ad_config_app/polaris/test',
    polarisClearCache: '/ad_config_app/polaris/clear-cache',
  },

  // 内容运营通用 CRUD（scene-tags / voices / schedule-templates）
  operations: {
    base: (res: string) => `/operations_app/${res}`,
    detail: (res: string, id: number) => `/operations_app/${res}/${id}`,
  },

};

// 默认请求头
export const DEFAULT_HEADERS = {
  'Content-Type': 'application/json',
};

/**
 * 构建完整的 API URL
 */
export function buildApiUrl(endpoint: string, params?: Record<string, any>): string {
  let url = `${API_BASE_URL}${endpoint}`;
  
  if (params) {
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== '') {
        queryParams.append(key, String(value));
      }
    });
    const queryString = queryParams.toString();
    if (queryString) {
      url += `?${queryString}`;
    }
  }
  
  return url;
}
